import { viewReset } from '../Entity/View';

export const RESET_EXERCISE_SUBMISSIONS = 'RESET_EXERCISE_SUBMISSIONS';
export const exerciseSubmissionsReset = () => ({
  type: RESET_EXERCISE_SUBMISSIONS,
});

export const resetExerciseSubmissions = () => {
  return (dispatch) => {
    dispatch(viewReset('exercise_answers'));
    dispatch(exerciseSubmissionsReset());
  };
};
